export default "__VITE_ASSET__831b37fe__"